import type { RelevancyThreshold } from '@/types/Schedule'

export const EARLIEST_YEAR_TO_NOT_SHOW_DUE_DATE: number = 2049
export const LATEST_YEAR_TO_NOT_SHOW_DUE_DATE: number = 2000

export const RELEVANCE_LABELS: Record<RelevancyThreshold, string> = {
  high: 'Highly Relevant',
  medium: 'Relevant',
  low: 'Not Relevant',
}

export const RELEVANCE_INDICES: Record<RelevancyThreshold, number> = {
  high: 0,
  medium: 1,
  low: 2,
}
